import { BuildClass, Do, clamp, fsmData, timer } from '../../universal';
import { React, _ } from '../lib';
import { getScrollbarWidth } from './component-main';
import { j2r } from './component-react';
import { Bindings } from './ui5';
export class J2rListComponent extends React.Component {
    listElement;
    hiddenInput;
    moveSelectionPending;
    cachedRows;
    cachedRowValues;
    init;
    lastRowCount;
    sortableObj;
    constructor(props) {
        super(props);
        Bindings(this, [
            this.contextMenuHandler,
            this.evBlur,
            this.evFocus,
            this.evKeydown,
            this.Focus,
            this.moveSelectionInner,
        ]);
        this.listElement = React.createRef();
        this.hiddenInput = React.createRef();
        this.moveSelectionPending = 0;
        this.cachedRows = null;
        this.cachedRowValues = null;
        this.init = false;
        this.lastRowCount = -1;
        this.state = {
            value: props.value,
            scrollPosition: 0,
            focused: false,
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
        if (!_.isEqual(prevProps.items, this.props.items)) {
            this.cachedRowValues = null;
            this.cachedRows = null;
            this.setState({});
        }
    }
    componentDidMount() {
        this.init = true;
        const fn = (v) => {
            if (v != null) {
                this.setState({ scrollPosition: v });
            }
        };
        const timeout = this.props.lazyThrottleMs ?? 50;
        const dbfn = _.throttle(fn, timeout, {
            leading: true,
            trailing: true,
        });
        this.listElement.current?.addEventListener('scroll', () => {
            dbfn(this.listElement.current?.scrollTop);
        });
        if (this.props.sortable) {
            const params_default = { direction: 'vertical' };
            const params = _.assign({}, params_default, this.props.sortable);
            this.sortableObj = Sortable.create(this.listElement.current, params);
        }
        if (this.state.value != null) {
            this.scrollToItem(null, 0);
        }
    }
    componentWillUnmount() {
        this.init = false;
        this.sortableObj?.destroy();
    }
    onUpdate() {
        ;
        (this.props.onUpdate ?? _.noop)(this.state.value);
    }
    render() {
        return j2r({
            cl: BuildClass({
                j2rlist: true,
                [this.props.cl ?? '']: true,
            }),
            style: this.props.style,
            children: _.compact([
                this.buildHeadingRow(),
                this.buildContentRows(),
                !this.props.disableFocusControl ? this.buildHiddenInput() : undefined,
            ]),
            onClick: this.Focus,
        });
    }
    buildHeadingRow() {
        const item = this.props.headingRow;
        if (!item) {
            return null;
        }
        return _.assign({}, item, {
            key: item.key ?? 'heading',
            cl: BuildClass({
                [item.cl ?? '']: true,
                item: true,
            }),
            style: _.assign({}, item.style ?? {}, {
                paddingRight: `${getScrollbarWidth()}px`,
            }),
            title: item.title ?? item.text,
        });
    }
    buildContentRows() {
        return {
            cl: 'rows',
            key: 'row-list',
            ref: this.listElement,
            children: Do(() => {
                const rows = this.calculateRenderedRows(this.getRows());
                return rows.map((x) => x());
            }),
        };
    }
    buildHiddenInput() {
        return {
            cl: 'hidden-input',
            key: 'hidden-input',
            children: [
                {
                    tag: 'input',
                    readOnly: true,
                    key: 'hidden-input-inner',
                    ref: this.hiddenInput,
                    onFocus: this.evFocus,
                    onBlur: this.evBlur,
                    onKeyDown: this.evKeydown,
                },
            ],
        };
    }
    evFocus() {
        this.setState({ focused: true });
    }
    evBlur() {
        this.setState({ focused: false });
    }
    evKeydown(e) {
        const defEv = (e) => {
            switch (e.keyCode) {
                case 33:
                    this.moveSelection(-12, e.shiftKey);
                    break;
                case 34:
                    this.moveSelection(+12, e.shiftKey);
                    break;
                case 38:
                    this.moveSelection(-1, e.shiftKey);
                    break;
                case 40:
                    this.moveSelection(+1, e.shiftKey);
                    break;
                default:
                    return;
            }
            e.preventDefault();
            e.stopPropagation();
        };
        if (this.props.onKeyDown != null) {
            this.props.onKeyDown(e, defEv);
        }
        else {
            defEv(e);
        }
    }
    Focus() {
        if (!this.props.disableFocusControl) {
            this.hiddenInput.current?.focus();
        }
    }
    getRows() {
        if (this.cachedRows != null) {
            return this.cachedRows;
        }
        const getItem = (itemRaw) => () => {
            const item = _.isFunction(itemRaw) ? itemRaw() : itemRaw;
            return _.assign({}, _.omit(item, ['selectable', 'value']), {
                key: item.value,
                'data-key': item.value,
                cl: BuildClass({
                    [item.cl ?? '']: true,
                    item: true,
                    selected: (!(this.props.multiple ?? false) &&
                        item.value === this.state.value) ||
                        ((this.props.multiple ?? false) &&
                            _.includes(this.state.value, item.value)),
                }),
                title: item.title ?? item.text,
                onContextMenu: this.contextMenuHandler(item),
                onClick: Do(() => {
                    let default_event = (e) => {
                        const [ctrlKey, shiftKey] = [e.ctrlKey, e.shiftKey];
                        this.setState(s => ({
                            ...s,
                            ...this.clickHandler(s, item.value, ctrlKey, shiftKey),
                        }), () => {
                            this.onUpdate();
                        });
                    };
                    if (!(item.selectable ?? true)) {
                        default_event = _.noop;
                    }
                    if (item.onClick != null) {
                        return (e) => item.onClick?.(e, default_event);
                    }
                    return default_event;
                }),
            });
        };
        const rows = _.map(this.props.items, x => {
            if ('getItem' in x) {
                return {
                    rowFn: getItem(x.getItem),
                    lazyRenderHeight: x.lazyRenderHeight,
                };
            }
            return { rowFn: getItem(x) };
        });
        this.cachedRows = rows;
        return rows;
    }
    contextMenuHandler(item) {
        if (item.onContextMenu == null) {
            return undefined;
        }
        return (e) => {
            e.persist();
            if (this.props.multiple && !this.state.value.includes(item.value)) {
                this.setState({ value: [item.value] }, () => {
                    item.onContextMenu(this.state.value, e);
                    this.onUpdate();
                });
            }
            else if (!this.props.multiple && item.value !== this.state.value) {
                this.setState({ value: item.value }, () => {
                    item.onContextMenu(this.state.value, e);
                    this.onUpdate();
                });
            }
            else {
                item.onContextMenu(this.state.value, e);
            }
        };
    }
    clickHandler(state, clickedValue, ctrlKey, shiftKey) {
        timer(() => {
            this.Focus();
        });
        if (this.props.readOnly) {
            return {};
        }
        return {
            value: Do(() => {
                const curr = state.value ?? (this.props.multiple ? [] : null);
                if (!this.props.multiple) {
                    return clickedValue;
                }
                const multi_select = this.props.multipleDefault || ctrlKey || shiftKey;
                if (!multi_select) {
                    if (_.includes(curr, clickedValue) && curr.length === 1) {
                        return [];
                    }
                    return [clickedValue];
                }
                if (!shiftKey || curr.length === 0) {
                    if (curr.includes(clickedValue)) {
                        return curr.filter((x) => x !== clickedValue);
                    }
                    return curr.concat(clickedValue);
                }
                const items = this.getRowValues();
                const clickedIndex = items.indexOf(clickedValue);
                const lastIndex = items.indexOf(curr[curr.length - 1]);
                const diff = clickedIndex > lastIndex ? 1 : -1;
                const inBetween = _.range(lastIndex, clickedIndex + diff, diff).map(i => items[i]);
                const allSelected = _.every(_.map(inBetween, x => curr.includes(x)));
                if (allSelected) {
                    return curr.filter((x) => !inBetween.includes(x));
                }
                return _.uniq(curr.concat(inBetween));
            }),
        };
    }
    getRowValues() {
        if (this.cachedRowValues != null) {
            return this.cachedRowValues;
        }
        const items = _.map(this.props.items, x => {
            if ('getItem' in x) {
                return x.getItem();
            }
            else if (_.isFunction(x)) {
                return x();
            }
            return x;
        });
        const values = fsmData(items, {
            filter: x => x.selectable ?? true,
            map: x => x.value,
        });
        this.cachedRowValues = values;
        return values;
    }
    calculateRenderedRows(rows) {
        let client_height, height, scroll_height;
        if (this.props.lazyRenderHeight == null) {
            return rows.map(x => x.rowFn);
        }
        const LRH = Do(() => {
            if (_.isFunction(this.props.lazyRenderHeight)) {
                return this.props.lazyRenderHeight();
            }
            return this.props.lazyRenderHeight;
        });
        const BUFFER_HEIGHT = 80;
        const ARBITRARY_HEIGHT = window.innerHeight;
        if (this.props.lazyRenderViewportHeightOverride != null) {
            height = this.props.lazyRenderViewportHeightOverride;
        }
        else if (this.listElement.current != null) {
            const rects = this.listElement.current.getClientRects();
            height = rects[0]?.height ?? ARBITRARY_HEIGHT;
            client_height = height;
            scroll_height = this.listElement.current?.scrollHeight ?? 0;
        }
        else {
            height = ARBITRARY_HEIGHT;
        }
        const scrollRange = [
            this.state.scrollPosition,
            this.state.scrollPosition + height,
        ];
        const top_cutoff_h = clamp(scrollRange[0] - BUFFER_HEIGHT, 0, undefined);
        const bot_cutoff_h = clamp(scrollRange[1] + BUFFER_HEIGHT, 0, undefined);
        const heights = _.map(rows, x => x.lazyRenderHeight ?? LRH);
        let full_height = 0;
        let top_cutoff_i = null;
        let bot_cutoff_i = null;
        _.map(heights, (height, i) => {
            const new_full_height = full_height + height;
            if (top_cutoff_i == null && new_full_height > top_cutoff_h) {
                top_cutoff_i = i;
                if (top_cutoff_i % 2 === 1) {
                    top_cutoff_i -= 1;
                }
            }
            if (bot_cutoff_i == null && full_height > bot_cutoff_h) {
                bot_cutoff_i = i;
            }
            full_height = new_full_height;
        });
        if (bot_cutoff_i == null) {
            bot_cutoff_i = rows.length;
        }
        if (full_height !== _.sum(heights)) {
            console.warn(`Mismatches heights: ${full_height}, ${_.sum(heights)}`, this.listElement.current);
        }
        if (rows.length === this.lastRowCount &&
            scroll_height !== client_height &&
            scroll_height &&
            full_height !== scroll_height) {
            console.warn(`Mismatches in DOM heights: ${full_height} vs ${scroll_height}`, this.listElement.current);
        }
        this.lastRowCount = rows.length;
        let top_height = 0;
        let bot_height = 0;
        _.map(heights, (h, i) => {
            if (i < top_cutoff_i) {
                top_height += h;
            }
            else if (i >= bot_cutoff_i) {
                bot_height += h;
            }
        });
        rows = rows.slice(top_cutoff_i, bot_cutoff_i);
        const rowFns = rows.map(x => x.rowFn);
        rowFns.unshift(() => ({
            key: 'spacer-above',
            cl: 'spacer',
            style: { height: `${top_height}px` },
        }));
        rowFns.push(() => ({
            key: 'spacer-below',
            cl: 'spacer',
            style: { height: `${bot_height}px` },
        }));
        return rowFns;
    }
    selectAll() {
        if (!this.props.multiple) {
            console.warn('Called `selectAll` on non-multi-select list - not allowed');
            return;
        }
        const values = this.getRowValues();
        this.setState({ value: values }, () => {
            this.onUpdate();
        });
    }
    updateScrollPosition(offset) {
        if (this.listElement.current != null) {
            this.listElement.current.scrollTop = offset;
        }
        this.setState({ scrollPosition: offset });
    }
    scrollToItem(keys, highlight_duration, only_if_needed) {
        if (highlight_duration == null) {
            highlight_duration = 800;
        }
        if (only_if_needed == null) {
            only_if_needed = false;
        }
        if (keys == null) {
            keys = this.state.value;
        }
        if (keys == null) {
            return;
        }
        if (keys.constructor !== Array) {
            keys = [keys];
        }
        let selected_index = null;
        let key = null;
        const rows = this.getRows();
        let row = null;
        _.forEach(rows, (rowObj, index) => {
            row = rowObj.rowFn();
            if (_.includes(keys, row.key)) {
                selected_index = index;
                key = row.key;
                return false;
            }
            return true;
        });
        const heights = Do(() => {
            if (this.props.lazyRenderHeight == null) {
                const el = this.listElement.current?.children[selected_index ?? -1];
                const elRect = el?.getBoundingClientRect() ?? {
                    top: 0,
                    height: 0,
                };
                const parentRect = el?.offsetParent?.getBoundingClientRect() ?? {
                    top: 0,
                };
                return {
                    found: el != null,
                    offsetHeight: elRect.top - parentRect.top,
                    itemHeight: elRect.height,
                };
            }
            const LRH = Do(() => {
                if (_.isFunction(this.props.lazyRenderHeight)) {
                    return this.props.lazyRenderHeight();
                }
                return this.props.lazyRenderHeight;
            });
            return {
                found: selected_index != null,
                itemHeight: row?.lazyRenderHeight ?? LRH,
                offsetHeight: Do(() => {
                    let offset = 0;
                    _.forEach(rows, (x, i) => {
                        if (i >= (selected_index ?? -1)) {
                            return false;
                        }
                        offset += x.lazyRenderHeight ?? LRH;
                        return true;
                    });
                    return offset;
                }),
            };
        });
        if (!heights.found) {
            return;
        }
        const container = this.listElement.current;
        const rect = container?.getBoundingClientRect();
        const container_height = rect?.height ?? 600;
        const offset_current_top = container?.scrollTop ?? 0;
        const offset_current_bottom = offset_current_top + container_height;
        const offset_top = heights.offsetHeight;
        const offset_bottom = heights.offsetHeight + heights.itemHeight;
        if (offset_top < offset_current_top || offset_bottom > offset_current_bottom) {
            if (only_if_needed) {
                const padding_when_scroll_needed = 10;
                if (offset_top < offset_current_top) {
                    this.updateScrollPosition(offset_top - padding_when_scroll_needed);
                }
                else if (offset_bottom > offset_current_bottom) {
                    this.updateScrollPosition(offset_bottom - container_height + padding_when_scroll_needed);
                }
            }
            else {
                const offset_midpoint = Math.floor((offset_top + offset_bottom) / 2);
                let offset_from_top = Math.floor(offset_midpoint - container_height / 3);
                const max_offset = container
                    ? container.scrollHeight - container.clientHeight
                    : 0;
                offset_from_top = clamp(offset_from_top, 0, max_offset);
                this.updateScrollPosition(offset_from_top);
            }
        }
        if (highlight_duration) {
            timer(() => {
                const list = this.listElement.current;
                const el = list?.querySelector(`[data-key='${key}']`);
                const oldBG = el?.style.backgroundColor;
                const oldTrans = el?.style.transition;
                const anim = 200;
                if (el != null) {
                    el.style.transition = `background-color ${anim}ms`;
                    el.classList.add('highlighting');
                }
                timer(() => {
                    if (el != null) {
                        el.style.backgroundColor = '#ffb';
                    }
                    timer(highlight_duration + anim, () => {
                        if (el != null) {
                            el.style.backgroundColor = oldBG;
                        }
                        timer(anim, () => {
                            if (el != null) {
                                el.style.transition = oldTrans;
                                el.classList.remove('highlighting');
                            }
                        });
                    });
                });
            });
        }
    }
    moveSelection(delta, _shift = null) {
        this.moveSelectionPending += delta;
        requestAnimationFrame(this.moveSelectionInner);
    }
    moveDeltaGetValue(delta, currentValue) {
        let curentValue;
        if (currentValue == null) {
            currentValue = this.state.value;
        }
        if (this.props.multiple) {
            if (currentValue.length > 1) {
                console.warn('Arrow key selection on multi-select lists not yet supported');
                return currentValue;
            }
            curentValue = currentValue[0] ?? null;
        }
        else {
            curentValue = currentValue ?? null;
        }
        const items = this.getRowValues();
        const currentIndex = items.indexOf(curentValue);
        let newIndex = currentIndex + delta;
        if (newIndex < 0) {
            newIndex = 0;
        }
        else if (newIndex > items.length - 1) {
            newIndex = items.length - 1;
        }
        if (newIndex === currentIndex) {
            return null;
        }
        let v = items[newIndex];
        if (this.props.multiple) {
            v = [v];
        }
        return v;
    }
    moveSelectionInner() {
        const delta = this.moveSelectionPending;
        this.moveSelectionPending = 0;
        if (delta === 0 || !this.init) {
            return;
        }
        const value = this.moveDeltaGetValue(delta);
        if (value == null) {
            return;
        }
        this.scrollToItem(value, 0, true);
        this.setState({ value }, () => {
            this.onUpdate();
        });
    }
}
//# sourceMappingURL=component-react-list.js.map